import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const timerecordOrderDataClassName = DataClassName.TIMERECORD_ORDER
const timerecordOrderEndpoint = PisaDataClassEndpoint.TIMERECORD_ORDER

export function pisaTimerecordOrderDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(timerecordOrderDataClassName, {
    title: timerecordOrderDataClassName,
    restApi: createPisaRestApiConfig(timerecordOrderEndpoint),
    attributes,
  })
}
